import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { RadioButtonModule } from 'primeng/radiobutton';
import { OptionVariantEnum } from '../../models/formConfig.model';

@Component({
  standalone: true,
  selector: 'pm-form-field-radio-tile',
  imports: [ReactiveFormsModule, CommonModule, RadioButtonModule],
  templateUrl: './pm-form-field-radio-tile.component.html',
  styleUrl: './pm-form-field-radio-tile.component.scss',
})
export class PmFormFieldRadioTileComponent
  extends FormFieldComponent
  implements AfterViewInit
{
  @ViewChild('container', { read: ElementRef })
  container!: ElementRef<HTMLElement>;

  ngAfterViewInit() {
    this.initComponent();
  }

  private initComponent() {
    const optionsVariant =
      this.formField.optionsVariant || OptionVariantEnum.LARGE;
    if (!this.container?.nativeElement) return;
    (this.container.nativeElement as HTMLElement).classList.add(optionsVariant);
  }

  onTileClick(value: any) {
    this.ctrl.setValue(value);
    this.ctrl.markAsDirty();
  }
}
